import Alpine from 'alpinejs'

// Alpine.store('activeProduct').activeProduct.variants;
// Array of product variant objects from Fusion or Shopify liquid
export const variantSizeSelection = (newVariants) => {

    if(Alpine.store('activeProduct').activeProduct.product_option_titles.length > 1) {
        let elms = document.querySelectorAll('.fusion-pdp__vselect-option');
        elms.forEach(function(elm) {
            elm.classList.remove('vselect_option--active');
            Alpine.store('selectedVariant').updateActiveVariant({
                "id": "",
                "title": "",
                "displayAtc": false
            });
            elm.disabled = false;
        });
        Alpine.store("vMultiSelect").updateActiveOptionTwo('');
        Alpine.store("vMultiSelect").updateActiveOptionOne('');
    }
    

    if(Alpine.store('activeProduct').activeProduct.product_option_titles.length > 1) return;

    const sizeVariantElms = document.querySelectorAll('.fusion-pdp__vselect-option');
    sizeVariantElms.forEach((elm, i) => {
        if (newVariants[i]?.available) {
            elm.removeAttribute('disabled')
            elm.id = newVariants[i].id;
        } else {

            // Alpine state reset
            if (elm.id == Alpine.store('selectedVariant').id) {
                Alpine.store('selectedVariant').updateActiveVariant({
                    "id": "",
                    "title": "",
                    "displayAtc": false
                });
            }

            elm.id = newVariants[i]?.id;
            elm.classList.remove('vselect_option--active')
            elm.setAttribute('disabled', 'disabled')
        }
    })
}
